import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
// import { StorageService } from "./storage/storageService";

@Injectable({
    providedIn: 'root'
})
export class SwipesumAPI {

    private API_URL = environment.apiUrl;
    private SET_ROOT  = environment.setRoot;
    //private AUTH_HEADER: string | null = null;

    public getDefaultHeaders(): HttpHeaders {
        return new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    public getMultipartHeaders(): HttpHeaders {
        // When sending multi-part requests, we have to let the browser
        // set the Content-type or else we'll be overriding the boundary
        // param that's needed on the service side to parse the request
        return new HttpHeaders({  });
    }

    public async apiCall(path:string,
        method: string,
        headers: HttpHeaders,
        params: Record<string, any> | null,
        data: unknown,
        options: any = { setRoot: true, authenticate: true, updateAuthHeader: false })
    {
        if (options == null) 
            options = {};

        // if (options.setRoot == null)
        //     options.setRoot = true;
        // if (options.authenticate == null)
        //     options.authenticate = true;
        // if (options.updateAuthHeader == null)
        //     options.updateAuthHeader = false;

        if (params != null) {
            const tmp = new URLSearchParams();
            for (const key in params as any)
                tmp.append(key,params[key]);

            path = `${path}?${tmp.toString()}`;
        }

        const url = ((path, setRoot) => {
            if (!setRoot)
                return path;

            return `${this.API_URL}${path}`;

        })(path, this.SET_ROOT);

        const fetchHeaders = new Headers();
        if (headers != null)
            for (const key of headers.keys()) {
                let k = headers.get(key)
                if (k != null) {
                    fetchHeaders.append(key, k);
                }
            }

        const fetchOpts: any  = {
            credentials: 'include',
            method: method,
            cache: 'no-store',
            headers: fetchHeaders
        };

        if (!['GET', 'HEAD'].includes(method) && data != null) {
            switch(fetchOpts.headers.get('Content-Type')) {
                case 'application/json':
                    fetchOpts.body = JSON.stringify(data);
                    break;
                default:
                    fetchOpts.body = data;
                    break;
            }
        }

        if (fetchOpts.headers.get('swipesum-origin') == null)
            fetchOpts.headers.set('swipesum-origin', 'portal-prod');

        if (options.authenticate) {
            // let authHeader = this.storage.getAuthHeader()

            // if (authHeader == null) {
            //     console.error('We are not authenticated properly. Consider throwing an error or signing out.');
            // }

            // fetchOpts.headers.set('Authorization', authHeader);
        }

        return fetch(url, fetchOpts)
        .then((res: Response) => { 

            return res.json()
            .then(o => {

                if (o && o.message !== undefined && o.message != "") {
                    console.log("gateway-api-service", "fetch", "error while fetching data", o);
                    throw o;
                }
                else if (res.status >= 300) {
                    // TODO (jacob): 
                    throw new Error(`Status code: ${res.status}`);
                }

                // TODO: This header will may not be present if the request failed on the server side.
                if (options.updateAuthHeader) {
                    const authHeader = res.headers.get('Authorization');
                    if (authHeader == null) {
                        // If this is a signin request, auth header will be expected but will not be
                        // set if 2-factor auth is required.  In that specific case, we should just
                        // swallow this.
                        console.error('Auth header expected but not found!');
                    }
                    else {
                        // this.storage.setAuthHeader(authHeader);
                    }
                }

                return o;
            })
        })
        // .catch(err => {
        //     if (!(err instanceof SyntaxError))
        //         throw err;
        // });
    }    

}
